module.exports = __webpack_public_path__ + "img/3shelter.33fdb38c.jpg";